import React from 'react'
import Link from 'next/link'
import { dateToDisplayDateOrEmpty, scrollToId } from 'utils/helpers'
import GenerateChallengeButton from 'components/shared/generate-challenge/GenerateChallengeButton'
import ScheduleCallButton from '../shared/ScheduleCallButton'
import UnsplashImage from 'components/shared/UnsplashImage'

interface ChallengeSpaceHeaderProps {
	space: any
	subject: any
	organisation: any
}

const ChallengeSpaceHeader = ({
	space,
	organisation,
	subject,
}: ChallengeSpaceHeaderProps) => {
	return (
		<div className="relative z-20 bg-gray-900">
			<div className="container mx-auto px-4 pt-10 pb-12 relative z-20">
				<div className="w-full md:w-1/2">
					{subject?.attributes?.title &&
						!space?.attributes?.isOpenChallengeSpace && (
							<span className="text-sm whitespace-nowrap rounded-full inline-block bg-purple-900 text-white relative z-10 px-3 py-1 mb-2 font-semibold">
								{subject?.attributes?.title}
							</span>
						)}
					<h1 className="text-3xl font-semibold mb-3 mt-0 text-white">
						{space.attributes.title}
					</h1>

					<div className="flex flex-col items-start mb-4 opacity-90">
						{space.attributes.useChallenges &&
							!space?.attributes?.isOpenChallengeSpace && (
								<span className="text whitespace-nowrap text-white uppercase">
									Period:{' '}
									{dateToDisplayDateOrEmpty(
										space.attributes.challengeStartDate
									)}{' '}
									-{' '}
									{dateToDisplayDateOrEmpty(space.attributes.challengeEndDate)}
								</span>
							)}
						{organisation && (
							<Link
								href={'/challenge-spaces/organisation/[slug]'}
								as={`/challenge-spaces/organisation/${organisation.attributes.slug}`}
								passHref
							>
								<span className="mt-1 text-white text-opacity-100 font-bold cursor-pointer hover:text-opacity-75 transition-colors duration-300">
									{organisation.attributes.name}
								</span>
							</Link>
						)}
					</div>
					{space.attributes.summary && (
						<p className="text-white opacity-90 mb-4">
							{space.attributes.summary}
						</p>
					)}
					<div
						className={
							'flex flex-col flex-wrap items-start md:flex-row md:items-end'
						}
					>
						{!space.attributes.submissionExpired &&
						space.attributes.useChallenges ? (
							<>
								<div className={'flex flex-col mt-auto'}>
									<button
										className={
											'bg-yellow-300 transition-colors duration-300 text-gray-900 hover:bg-yellow-200 z-10 relative mr-4 order-2'
										}
										onClick={() => scrollToId('submitSection')}
									>
										Submit challenge
									</button>
									{space.attributes.challengeSubmitDeadline &&
										!space?.attributes?.isOpenChallengeSpace && (
											<span
												className="text-xs text-left mb-4 block text-white order-1 md:order-1"
												style={{ maxWidth: '100%' }}
											>
												Submission deadline:{' '}
												<strong>
													{dateToDisplayDateOrEmpty(
														space.attributes.challengeSubmitDeadline
													)}
												</strong>
											</span>
										)}
								</div>
								<div className="mt-3 mb-1 mr-2 lg:my-0">
									<GenerateChallengeButton />
								</div>
							</>
						) : (
							space.attributes.useChallenges &&
							!space?.attributes?.isOpenChallengeSpace && (
								<div className="w-full mb-3">
									<span className="text-white self-center text-xs rounded-full px-3 py-1 bg-white bg-opacity-20 font-semibold">
										Deadline has passed
									</span>
								</div>
							)
						)}

						<ScheduleCallButton
							className="text-yellow-300 border border-yellow-300 mt-2 bg-black bg-opacity-40"
							externalCallUrl={space.attributes.externalCallUrl}
						/>
					</div>
				</div>
			</div>
			<div className="bg-gradient-to-b md:bg-gradient-to-r z-10 absolute from-gray-900 h-1/2 md:h-full right-0 bottom-0 top-auto md:top-0 w-full md:w-7/12"></div>
			<div className="absolute right-0 bottom-0 top-auto md:top-0 h-1/2 md:h-full w-full md:w-7/12">
				<UnsplashImage
					{...(space.attributes.unsplash ?? {})}
					title={space.attributes.title}
					width="1900"
					height="1000"
				/>
			</div>
		</div>
	)
}

export default ChallengeSpaceHeader
